export const defaultModalInputValues: { width: string } = {
  width: '500px',
}
